import { SIP_PREFIX } from './getSipUri';

export default function getEmailAddressFromSipUri(sipUri: string): string {
    if (!sipUri) {
        return null;
    }

    sipUri = sipUri.toLowerCase();
    if (sipUri.indexOf(SIP_PREFIX) == 0) {
        return sipUri.substring(SIP_PREFIX.length);
    }

    return sipUri;
}
